import { isFeatureEnabled } from 'owa-feature-flags';

export function shouldFetchContextualMRUAttachmentSuggestions(): boolean {
    return isFeatureEnabled('mc-replyWithContextualMRU');
}

export function shouldFetchMRUClassicAttachments(): boolean {
    // Due to ongoing experiment with mc-replyWith flight, we do NOT want to fetch classic attachments unless
    // this flight is enabled.
    return isFeatureEnabled('mc-replyWithMRUClassic');
}

// If enabled, we ensure that the MRU service returns at most one cloudy attachment,
// the rest being classic.
// For testing purposes only.
export function shouldLimitMRUCloudyAttachmentsToOne(): boolean {
    return isFeatureEnabled('mc-replyWithMRUCloudyLimited');
}

// There are a few environments where 3S is not available
// and attachment suggestions will not work there
// suggestion will not be enabled in those environments
export function attachmentSuggestionsEnabled(): boolean {
    return !isFeatureEnabled('doc-suppressAttachmentSuggestions');
}
